// src/sagas/usersSaga.js
import { call, put, select, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  loginLoad,
  loginSuccess,
  loginFailure,
  forgotPasswordLoad,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  checkLinkLoad,
  checkLinkSuccess,
  checkLinkFail,
  resetPasswordLoad,
  resetPasswordFailure,
  resetPasswordSuccess,
  logoutLoad,
  logoutSuccess,
  logoutFailure,
  skipApiLoad,
  changePasswordLoad,
  changePasswordSuccess,
  skipApiSuccess,
  createPasswordSuccess,
  createPasswordFailure,
  createPasswordLoad,
  signUpSuccess,
  signUpFailure,
  signUpLoad,
  otpSuccess,
  otpFailure,
  otpLoad,
  webTokenLoad,
  webTokenFailue,
  webTokenSuccess,
  userLoginFailure,
  userLoginSuccess,
  userLoginLoad,
} from "../slices/auth.slice";

import {
  LoginApi,
  changePasswordApi,
  checkLinkApi,
  createUserPasswordApi,
  forgotPasswordApi,
  getWebTokenApi,
  logutApi,
  otpApi,
  resetPasswordApi,
  signUpApi,
  skipApi,
  userLoginApi,
} from "../Api/api";
import { navigate } from "../../common/navigator";

import { toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils";
import {
  selectReferralCode,
  setRefloginComplete,
} from "../slices/referralSlice.slice";
import { selectToken, setUserToken } from "../slices/common.slice";

function* login(action) {
  try {
    const response = yield call(LoginApi, action.payload);

    if (response?.status == 0) {
      yield put(loginSuccess(response.data));
      toast.success(response?.result?.message);
      // if(response?.result?.data?.isFirstLogin)
      // {
      //         window.token =  response?.result?.data?.token;
      //         localStorage.setItem('adminType', response?.result?.data?.adminType)
      //         localStorage.setItem('userName', response?.result?.data?.adminType == "admin" ? "Admin" : capitalizeFirstLetter(response?.result?.data?.firstName + " " + response?.result?.data?.lastName))
      //         if (response?.result?.data?.accessRoutes) {
      //             let accessArray = response?.result?.data?.accessRoutes;
      //             let jsonString = JSON.stringify(accessArray);
      //             localStorage.setItem('accessArray', jsonString);
      //         }
      //         console.log(window?.token ,"token");
      //         navigate("/changepassword")

      // }

      localStorage.setItem("token", response?.result?.data?.token);
      localStorage.setItem("adminType", response?.result?.data?.adminType);
      localStorage.setItem(
        "userName",
        response?.result?.data?.adminType == "admin"
          ? "Admin"
          : capitalizeFirstLetter(
              response?.result?.data?.firstName +
                " " +
                response?.result?.data?.lastName
            )
      );
      if (response?.result?.data?.accessRoutes) {
        let accessArray = response?.result?.data?.accessRoutes;
        let jsonString = JSON.stringify(accessArray);
        localStorage.setItem("accessArray", jsonString);
      }
      navigate("/organizations");
    } else {
      yield put(loginFailure(response.data));
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(loginFailure(error.message));
  }
}

function* forgotPassword(action) {
  try {
    const response = yield call(forgotPasswordApi, action.payload);

    if (response?.status == 0) {
      yield put(forgotPasswordSuccess(response.data));
      toast.success(response?.result?.message);
      navigate("/instruction-sent");
    } else {
      yield put(forgotPasswordFailure(response.data));
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(forgotPasswordFailure(error.message));
  }
}

function* checklink(action) {
  try {
    const response = yield call(checkLinkApi, action.payload);

    if (response?.status == 0) {
      yield put(checkLinkSuccess());
    } else {
      yield put(checkLinkFail());
    }
  } catch (error) {
    yield put(checkLinkFail());
  }
}

function* resetPassword(action) {
  try {
    const response = yield call(resetPasswordApi, action.payload);

    if (response?.status == 0) {
      yield put(resetPasswordSuccess());
      navigate("/passwordcreated");
      toast.success(response?.result?.message);
    } else {
      yield put(resetPasswordFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(resetPasswordFailure());
  }
}

function* changeSaga(action) {
  try {
    const response = yield call(changePasswordApi, action.payload);

    if (response?.status == 0) {
      yield put(changePasswordSuccess());
      localStorage.clear();

      navigate("/");
      toast.success(response?.result?.message);
    } else {
      yield put(changePasswordSuccess());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(changePasswordSuccess());
  }
}

function* createPassSaga(action) {
  try {
    const response = yield call(createUserPasswordApi, action.payload);

    if (response?.status == 0) {
      yield put(createPasswordSuccess());

      navigate("/userlogin");
      toast.success(response?.result?.message);
    } else {
      yield put(createPasswordFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(createPasswordFailure());
  }
}

function* userLoginSaga(action) {
  try {
    const response = yield call(userLoginApi, action.payload);

    if (response?.status === 0) {
      const referralCode = yield select(selectReferralCode);
      localStorage.setItem("token", response?.result?.data?.token);
      yield put(setUserToken(response?.result?.data?.token));
      const payload = {
        promoRef: referralCode || "",
        token: response?.result?.data?.token,
      };
      const webResponse = yield put(webTokenLoad(payload));
      if (webResponse?.status === 0) {
      }

      toast.success(response?.result?.message);
    } else {
      yield put(userLoginFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(userLoginFailure());
  }
}

function* signUpSaga(action) {
  try {
    const response = yield call(signUpApi, action.payload);

    if (response?.status == 0) {
      yield put(signUpSuccess());

      navigate("/otp", { state: { email: action.payload.email } });
      toast.success(response?.result?.message);
    } else {
      yield put(signUpFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(signUpFailure());
  }
}

function* otpSaga(action) {
  try {
    const response = yield call(otpApi, action.payload);
    if (response?.status == 0) {
      const referralCode = yield select(selectReferralCode);
      localStorage.setItem("token", response?.result?.data?.token);
      yield put(setUserToken(response?.result?.data?.token));
      const payload = {
        promoRef: referralCode || "",
        token: response?.result?.data?.token,
      };
      const webResponse = yield put(webTokenLoad(payload));
      if (webResponse?.status === 0) {
      }

      toast.success(response?.result?.message);

      toast.success(response?.result?.message);
    } else {
      yield put(otpFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(otpFailure());
  }
}

function* webTokenSaga(action) {
  try {
    //type is user because if this api is getting called from web then only one type of payment is allowed, for now
    const response = yield call(getWebTokenApi, {
      promoRef: action.payload?.promoRef,
      type: "user",
      token: action.payload?.token,
    });
    if (response?.status === 0) {
      const refToken = response?.result?.data?.token;
      yield put(setRefloginComplete(refToken));
      localStorage.setItem("refLoginCompleteToken", refToken);
      yield put(webTokenSuccess(false));
      navigate("/subscriptionscreen", { replace: true });
      toast.success(response?.result?.message);
    } else {
      yield put(webTokenFailue());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(webTokenFailue());
  }
}

function* skipsaga(action) {
  try {
    const response = yield call(skipApi);

    if (response?.status == 0) {
      yield put(skipApiSuccess());
      localStorage.setItem("token", response?.result?.data?.token);

      navigate("/");
      toast.success(response?.result?.message);
    } else {
      toast.error(response?.result?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* logout() {
  try {
    const response = yield call(logutApi);

    if (response?.status == 0) {
      yield put(logoutSuccess());
      toast.success(response?.result?.message);
      localStorage.clear("token");
      navigate("/login");
    } else {
      yield put(logoutFailure());
      toast.error(response?.result?.message);
    }
  } catch (error) {
    yield put(logoutFailure());
  }
}

function* authSaga() {
  yield takeLatest(loginLoad.type, login);
  yield takeLatest(forgotPasswordLoad.type, forgotPassword);
  yield takeLatest(checkLinkLoad.type, checklink);
  yield takeLatest(resetPasswordLoad.type, resetPassword);
  yield takeLatest(logoutLoad.type, logout);
  yield takeLatest(changePasswordLoad.type, changeSaga);
  yield takeLatest(skipApiLoad.type, skipsaga);
  yield takeLatest(createPasswordLoad.type, createPassSaga);
  yield takeLatest(signUpLoad.type, signUpSaga);
  yield takeLatest(otpLoad.type, otpSaga);
  yield takeLatest(webTokenLoad.type, webTokenSaga);
  yield takeLatest(userLoginLoad.type, userLoginSaga);
}

export default authSaga;
